<!--
 * @Author: zcj
 * @Date: 2025-01-15 19:46:53
 * @LastEditTime: 2025-12-17 14:13:34
 * @LastEditors: 'zcj' '2736104855@qq.com'
 * @Description: 
 * @FilePath: \h5e:\travel-app\src\layouts\default.vue
-->
<template>
  <view class="page-bg">
    <view class="page-gradient"></view>
    <!-- <view class="page-elephant" aria-hidden="true"></view> -->
    <slot />
  </view>
</template>

<script lang="ts" setup></script>
<style lang="less">
.page-bg {
  width: 100%;
  height: auto;
  background: #edeef3;
  position: relative;
  overflow: hidden;

  .page-gradient {
    position: absolute;
    right: -148rpx;
    top: -148px;
    width: 400rpx;
    height: 400rpx;
    opacity: 1;
    /* #ifdef H5 */
    background: rgba(90, 179, 255, 0.55);
    filter: blur(200rpx);
    /* #endif */
    pointer-events: none; // 关键：让渐变层不拦截鼠标/触摸事件
  }

  .page-elephant {
    position: fixed;
    width: 420rpx;
    height: 320rpx;
    left: 52%;
    bottom: 160rpx;
    transform: translateX(-50%);
    background: url("@/static/logo.svg") no-repeat center / contain;
    mix-blend-mode: multiply;
    opacity: 0.1;
    filter: drop-shadow(0 12rpx 28rpx rgba(130, 164, 207, 0.25));
    pointer-events: none;
  }
}
</style>
